import { render, staticRenderFns } from "./InformacoesDadosSevHomePageComponent.vue?vue&type=template&id=1964d5a2&scoped=true"
import script from "./InformacoesDadosSevHomePageComponent.vue?vue&type=script&lang=js"
export * from "./InformacoesDadosSevHomePageComponent.vue?vue&type=script&lang=js"
import style0 from "./InformacoesDadosSevHomePageComponent.vue?vue&type=style&index=0&id=1964d5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1964d5a2",
  null
  
)

export default component.exports